<template>
  <div >
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false">
      <md-dialog-title class = "heading">Outbound Remark</md-dialog-title>

      <md-dialog-content >
        <form id = "top"> 
          <div class = "down">
            <tr>
              <th>SeqNo:</th>
              <td>{{dataForm.seqNo}}</td>
            </tr>
            <tr>
              <th>Container No:</th>
              <td>{{dataForm.containerNo}}</td>
            </tr>
            <tr>
              <th>Receiving Window:</th>
              <td>{{dataForm.receivingWindow}}</td>
            </tr>
            <tr v-if="!(dataForm.remarkLastUpdatedBy == null || dataForm.remarkLastUpdatedBy == '')">
              <th>Remark Last Updated By:</th>
              <td>{{dataForm.remarkLastUpdatedBy}}</td>
            </tr>
            <tr v-if="!(dataForm.remarkLastUpdatedAt == null || dataForm.remarkLastUpdatedAt == '')">
              <th>Remark Last Updated At:</th>
              <td>{{dataForm.remarkLastUpdatedAt}}</td>
            </tr>
            
            <md-field >
              <label class = "textlabel" for="loadRemark">Remark</label>
              <!--<md-input v-model="dataForm.outboundRemark" :disabled="!this.getPermission.fsiMgtWithRemark.edit || this.mode != 'update'"/>-->
              <md-textarea v-model="dataForm.outboundRemark" :disabled="!this.getPermission.fsiMgtWithRemark.edit || this.mode != 'update'"/>
            </md-field>
          </div>
        </form>
        
        <div class = "heading">
          <calling-api-center :paths="['/api/w/fsi/WebSaveOutbound']"></calling-api-center>
            <md-dialog-actions >
              <md-button class="custButtonForm md-raised" @click="doSaveUser" :disabled="!this.getPermission.fsiMgtWithRemark.edit || this.mode != 'update'"><span class="icons-center material-icons">edit</span>Update</md-button>
              <md-button class="md-raised custButtonForm " @click="cancalAction"><span class="icons-center material-icons">cancel</span>Leave</md-button>
            </md-dialog-actions>
        </div>
      </md-dialog-content>
    </md-dialog>
  </div>
</template>

<style scoped>
@import '../../public/chrisForm.css';

form {
    min-width: 640px;
    margin: 5px;
    color: #000000;
    font-size: 24px;
  }

.heading {
    padding-top: 0px;
    padding-left: 0px;
    margin-bottom: 0;
    color: #000292;
    width: 92%;
    line-height: 2;
    font-size: 24px;
    font-family: Roboto Slab;
    margin-left: 10px;
  }

#top {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 16px;
  margin-top: 5px;
  margin-left: 0px;
}
#top th{
  text-align: left;
  color: #000292
}
#top td{
  padding-left: 10px;
  padding-top: 5px;
}

</style>

<script>
  import { mapGetters } from 'vuex';
  import callingApiCenter from "./CallingApiCenter.vue";
  import AutocompleteCcicLocationSelect from "./AutocompleteCcicLocationSelect.vue";
  //import api from '../api';
  import { newAPIPost } from '../api/index.js';

  const getInitialdataForm = () => ({
    mode: "RMK",
    user: null,
    username: null,
    seqNo: null,
    containerNo: null,
    outboundRemark: null,
    receivingWindow: null,
    remarkLastUpdatedBy: null,
    remarkLastUpdatedAt: null
  });
  // const initSaveRequest = () => ({
  //   mode: "RMK",
  //   user: null,
  //   username: null,
  //   seqNo: null,
  //   containerNo: null,
  //   outboundRemark: null,
  // });

  export default {
    //components: { },
    props: {
      mode: String,
      onRefresh: Function,
    },
    data: () => ({
      showDialog: false,
      dataForm: getInitialdataForm(),
      //searchRequest: initSaveRequest(),
      saveOutboundRemarkRequest:{
        mode: " ",
        user: " ",
        username: " ",
        seqNo: " ",
        containerNo: " ",
        outboundRemark: " ",
      },
    }),
    components: {
      AutocompleteCcicLocationSelect ,callingApiCenter
    },

    computed: {
      ...mapGetters([
        'getMasterDataByGroup',
        'getMasterDataName',
        'getUserProfile',
        'getPermission',
      ]),

    },

    validations: {
      dataForm: {
      
      },
    },
 
    methods: {

      openDialog(existingUser) {
        this.$store.commit('clearApiError');
       
       
        this.$v.dataForm.$reset();

        console.log(this.$v.dataForm.$invalid);
        this.dataForm = getInitialdataForm();
      
        if (existingUser) {
          
          console.log("existinguser: " + JSON.stringify(existingUser));
            var convertdatetime = this.getUpdateDateTime(existingUser.remarkLastUpdatedAt);
            this.dataForm.mode = "RMK",
            this.dataForm.user = existingUser.user,
            this.dataForm.username = this.getUserProfile.username,
            this.dataForm.seqNo = existingUser.seqNo,
            this.dataForm.containerNo = existingUser.containerNo,
            this.dataForm.outboundRemark = existingUser.outboundRemark,
            this.dataForm.receivingWindow = existingUser.receivingWindows,
            this.dataForm.remarkLastUpdatedBy = existingUser.remarkLastUpdatedBy,
            //this.dataForm.remarkLastUpdatedAt = existingUser.remarkLastUpdatedAt
            this.dataForm.remarkLastUpdatedAt = convertdatetime;
        }

        this.showDialog = true;
      },

      cancalAction(){
          this.showDialog = false;
          this.$store.commit('clearApiError');
      },
      
      initSaveOutboundRemarkRequest()
      {
        this.saveOutboundRemarkRequest.mode = "";
        this.saveOutboundRemarkRequest.user = "";
        this.saveOutboundRemarkRequest.username = "";
        this.saveOutboundRemarkRequest.seqNo = "";
        this.saveOutboundRemarkRequest.containerNo = "";
        this.saveOutboundRemarkRequest.outboundRemark = "";
          
      },
      getUpdateDateTime(p_datetime)
      {
          console.log("In remark update date: " + p_datetime);
          var retval = p_datetime;
          if (p_datetime != null && p_datetime != '')
          {
            //  var outputdatetime = new Date();
            //  if (outputdatetime != null)
            //  {
            //     var outputyear = outputdatetime.getFullYear().toString();
            //     var outputmonth = outputdatetime.get .getMonth().toString();
            //     var outputday = outputdatetime.getDay().toString();
            //     var outputhour = outputdatetime.getHours().toString();
            //     var outputmin = outputdatetime.getMinutes().toString();
            //     var outputsec = outputdatetime.getSeconds().toString();
            //     //retval = `${outputmonth}/${outputday}/${outputyear} ${outputhour}:${outputmin}:${outputsec}`;
            //     retval = outputmonth + "/" + outputday + "/" + outputyear + " " + outputhour + ":" + outputmin + ":" + outputsec;
            //     console.log("retval value from remark update date: " + retval);
            //  }
            if (p_datetime.indexOf('T') > 0)
            {
               retval = p_datetime.replace('T',' ');
            }
          }
          console.log("retval value from remark update date: " + retval);
          return retval;
      },
      doSaveUser() {
          this.initSaveOutboundRemarkRequest();
          this.saveOutboundRemarkRequest.mode = this.dataForm.mode;
          this.saveOutboundRemarkRequest.user = this.dataForm.user;
          this.saveOutboundRemarkRequest.username = this.dataForm.username;
          this.saveOutboundRemarkRequest.seqNo = this.dataForm.seqNo;
          this.saveOutboundRemarkRequest.containerNo = this.dataForm.containerNo;
          this.saveOutboundRemarkRequest.outboundRemark = this.dataForm.outboundRemark;
          // this.saveOutboundRemarkRequest.mode = this.dataForm.mode;
          // this.saveOutboundRemarkRequest.user = this.dataForm.user;
          // this.saveOutboundRemarkRequest.username = this.dataForm.username;
          // this.saveOutboundRemarkRequest.seqNo = this.dataForm.seqNo;
          // this.saveOutboundRemarkRequest.containerNo = this.dataForm.containerNo;
          // this.saveOutboundRemarkRequest.outboundRemark = this.dataForm.outboundRemark;
          const request = this.saveOutboundRemarkRequest;
          //api.post('/api/w/fsi/WebSaveOutbound',request)
          newAPIPost('/api/w/fsi/WebSaveOutbound',request)
          this.showDialog = false;
          this.onRefresh(this.dataForm.outboundRemark);
      },
   
    },
  }
      
</script>


